// extracted by mini-css-extract-plugin
export default {"container":"ScrollToTopButton_container__5QSli"};